import { SentryFilter } from 'sentryFilters/types'

export const extensionBugFilters: SentryFilter[] = [
  {
    name: 'extension-error',
    description: 'Filter out browser extension errors by checking stack frames',
    match: (event, hint) => {
      // Filter out browser extension errors by checking stack frames
      const frames = event.exception?.values?.[0]?.stacktrace?.frames || []
      const isExtensionError = frames.some((frame: any) => {
        const filename = frame?.filename || ''
        return (
          filename.includes('extension') ||
          filename.includes('webauthninterceptor') ||
          filename.startsWith('chrome-extension://') ||
          filename.startsWith('moz-extension://') ||
          filename.startsWith('safari-extension://')
        )
      })
      return isExtensionError
    },
  },
]
